import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initNativeApp } from './utils/nativeInit';

// Initialize native app features (safe to call on web)
initNativeApp().catch(err => console.warn('Native initialization failed:', err));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);